<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Edit Major Body Part :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link to="/incidents">
                            <i class="fa fa-stethoscope"></i> Incidents
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link to="/incidents/settings#body_parts">
                            Settings - Major Body parts
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        <template v-if="major_body_part_id"><i class="fa fa-edit"></i> Edit Major Body Part</template>
                        <template v-else><i class="fa fa-plus"></i> New Major Body Part</template>
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-7 col-lg-10 col-md-12 col-12">
                    <div class="card">
                        <div class="card-body">
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.BodyPartName }" class="row">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Major Body Part Name:</label>
                                <div class="col-sm-8">
                                    <input type="text" name="BodyPartName" v-model="major_body_part.BodyPartName" class="form-control" placeholder="Enter Major Body Part Name" />
                                    <span v-if="errors.BodyPartName" class="text-danger">
                                        <span v-for="error in errors.BodyPartName">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true}" class="row">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Is Active:</label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="major_body_part.IsActive" :value="1" :unchecked-value="0" plain />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            <button type="button" class="btn btn-success" v-on:click="saveMajorBodyPart(this)" :disabled="saving">
                Save Major Body Part
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                major_body_part_id: this.$route.params.id,
                major_body_part: {},
                errors: {},
            }
        },

        methods: {
            getErrorClass: function(attribute) {
                return {
                    'form-group has-error': this.errors[attribute],
                    'form-group': !this.errors[attribute],
                }
            },
            getMajorBodyPart: function() {
                //Get the data
                this.$http
                    .get('admin/major-body-parts-edit' + (this.major_body_part_id ? '/' + this.major_body_part_id : ''))
                    .then(response => {
                        //Set all the data
                        this.major_body_part = response.data;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveMajorBodyPart: function() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('admin/major-body-parts-edit' + (this.major_body_part_id ? '/' + this.major_body_part_id : ''), this.major_body_part)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Major Body Part Saved');

                    //Return to main list?
                    this.$router.push('/incidents/settings#body_parts');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get the incidents
            this.getMajorBodyPart();
        }
    }
</script>
